import {
  getGroups,
  retrieveKeysList
} from "@/ConfigService/ConfigServiceDataService"
import * as mutations from "./constants/mutation-types"
import * as actions from "./constants/action-types"

export const configService = {
  namespaced: true,
  state: {
    sideSheetVisible: false,
    groupsList: [],
    selectedKey: {},
    selectedGroup: {},
    detailsLoading: false,
    keyValueDetails: {},
    isEditMode: false,
    keyValueDetailsRetrieved: false,
    configError: {
      status: "",
      message: ""
    },
    loadingGroups: false,
    keysList: []
  },
  mutations: {
    [mutations.SET_CONFIG_DETAILS_SIDE_SHEET](state, value) {
      state.sideSheetVisible = value
    },
    [mutations.SET_GROUPS_LIST](state, value) {
      state.groupsList = value
    },
    [mutations.SET_SELECTED_KEY](state, value) {
      state.selectedKey = value
    },
    [mutations.SET_SELECTED_GROUP](state, value) {
      state.selectedGroup = value
    },
    [mutations.SET_DETAILS_LOADING](state, value) {
      state.detailsLoading = value
    },
    [mutations.SET_KEY_VALUE_DETAILS](state, value) {
      state.keyValueDetails = value
    },
    [mutations.SET_IS_EDIT_MODE](state, value) {
      state.isEditMode = value
    },
    [mutations.SET_KEY_VALUE_DETAILS_RETRIEVED](state, value) {
      state.keyValueDetailsRetrieved = value
    },
    [mutations.SET_CONFIG_ERROR](state, value) {
      state.configError = value
    },
    [mutations.SET_LOADING_GROUPS](state, value) {
      state.loadingGroups = value
    },
    [mutations.SET_KEYS_LIST](state, value) {
      state.keysList = value
    }
  },
  actions: {
    [actions.GET_GROUPS](context) {
      return new Promise(resolve => {
        getGroups().then(response => {
          context.commit(mutations.SET_GROUPS_LIST, response)
          resolve()
        })
      })
    },
    [actions.GET_KEY_DETAILS](context, { groupName, key }) {
      context.commit(mutations.SET_DETAILS_LOADING, true)
      context.commit(mutations.SET_KEY_VALUE_DETAILS_RETRIEVED, false)
      return new Promise((resolve, reject) => {
        return retrieveKeysList(groupName, key)
          .then(response => {
            context.commit(mutations.SET_CONFIG_ERROR, "")
            context.commit(mutations.SET_KEY_VALUE_DETAILS, response.data)
            context.commit(mutations.SET_KEY_VALUE_DETAILS_RETRIEVED, true)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutations.SET_CONFIG_ERROR, error.response.status)
            return reject(error)
          })
          .finally(() => {
            context.commit(mutations.SET_DETAILS_LOADING, false)
          })
      })
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/configService.js